import { useState } from 'react'
import { useGate } from 'statsig-react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import { Drawer, Button, Input, message, Alert } from 'antd'
import { useTranslation } from 'react-i18next'
import { resetTask, makeDelivery } from '../../flag-management.services'
import { getJob } from '../../../jobs/jobs.services'
import { useAuth } from '../../../../auth/Auth.hook'

const { TextArea } = Input
const RESET = 'RESET'
const DELIVERY = 'DELIVERY'
const DELIVERING = 'DELIVERING'

const ConfirmModal = Form.create()((props) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const isGetDetailJobByNebulaActive = useGate('is_get_detail_job_by_nebula_active').value
  const { userInfo } = useAuth()

  const sendReset = async (comment) => {
    setLoading(true)
    const { jobId, taskId, setSelectedJob, jobsSearch, onClose } = props
    const updatedJob = await resetTask(jobId, taskId, comment)
    if (updatedJob) {
      message.success(t('jobs.tasks.reset.reset'))
      props.form.resetFields()
      if (jobsSearch) setSelectedJob(updatedJob)
      onClose()
    }
    setLoading(false)
  }

  const delivery = async (comment) => {
    setLoading(true)
    const { jobId, setSelectedJob, onClose, task } = props
    const { steps, uuid } = task
    const delivering = steps.find((step) => step.type.name === DELIVERING)
    const updatedJob = await makeDelivery(jobId, uuid, delivering.uuid, comment)
    if (updatedJob) {
      if (isGetDetailJobByNebulaActive) {
        setSelectedJob()
        message.success(t('jobs.tasks.delivery.success'))
        props.form.resetFields()
      } else {
        setTimeout(async () => {
          const response = await getJob(jobId)
          setSelectedJob(response)
          props.setJob(response)
          message.success(t('jobs.tasks.delivery.success'))
          props.form.resetFields()
        }, 3000)
      }
      onClose()
    }
    setLoading(false)
  }

  const send = (event) => {
    event.preventDefault()
    const { type } = props
    props.form.validateFields((err, values) => {
      if (!err) {
        const { comment } = values
        if (type === RESET) {
          sendReset(comment)
        }
        if (type === DELIVERY) {
          delivery(comment)
        }
      }
    })
  }

  const onClose = () => {
    props.onClose()
    props.form.resetFields()
    setLoading(false)
  }

  const { getFieldDecorator } = props.form
  const { taskName, type } = props
  let title = `${t('jobs.tasks.reset.form.title1')} ${taskName ? t(`jobs.tasks.name.${taskName}`) : null} ${t(
    'jobs.tasks.reset.form.title2'
  )}`
  title = type === DELIVERY ? t('jobs.tasks.delivery.title') : title
  return (
    <Drawer className='confirm-modal' title={title} width={500} onClose={onClose} visible={props.visible}>
      <Form layout='vertical' onSubmit={send}>
        <div>
          {type === DELIVERY ? (
            <Alert
              message={
                <div className='alert-warning-text'>
                  {`${t('jobs.tasks.delivery.first-alert')} `}
                  <b className='second-alert'>{t('jobs.tasks.delivery.second-alert')}</b>
                </div>
              }
              type='warning'
            />
          ) : null}
          <p className='confirm-summary'>
            {type === RESET ? `${t('jobs.tasks.reset.comment')}` : `${t('jobs.tasks.delivery.comment')}`}
          </p>
        </div>
        <Form.Item>
          {getFieldDecorator('comment', {
            rules: [{ required: true, message: t('jobs.tasks.reset.form.comment.message') }]
          })(<TextArea rows={4} placeholder={t('jobs.tasks.reset.form.comment.placeholder')} />)}
          <span>{t('jobs.tasks.reset.responsible')}: </span>
          <b>
            {userInfo?.user.firstName} {userInfo?.user.lastName}
          </b>
        </Form.Item>
        <div className='confirm-modal-footer'>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            {t('jobs.tasks.reset.form.cancel')}
          </Button>
          <Button loading={loading} htmlType='submit' type='primary'>
            {t('jobs.tasks.reset.form.accept')}
          </Button>
        </div>
      </Form>
    </Drawer>
  )
})

export default ConfirmModal
